'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$scope', '$uibModalInstance', 'quarters',
    function ($scope, $modalInstance, quarters) {

        $scope.ok = ok;
        $scope.cancel = cancel;

        init();

        // region Function

        function init() {
            $scope.quarters = angular.copy(quarters);
        }

        function ok() {
            $modalInstance.close($scope.quarter);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        // endregion

    }];